// extracted by mini-css-extract-plugin
export default {"toLoginPage":"BackToLoginPageButton_toLoginPage__u4pg9","arrowIcon":"BackToLoginPageButton_arrowIcon__YmMze","buttonLabel":"BackToLoginPageButton_buttonLabel__2+loo"};